import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=fe1aaa36&scoped=true&"
import script from "./IconView.vue?vue&type=script&lang=js&"
export * from "./IconView.vue?vue&type=script&lang=js&"
import style0 from "./IconView.vue?vue&type=style&index=0&id=fe1aaa36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1aaa36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
